// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes pulse{0%,50%,to{opacity:.1}70%{opacity:.18}}.skeleton-rect{display:inline-block;overflow:hidden;width:100px;height:1em;background-color:currentColor;transform:scaleY(1.2);animation:pulse 2.5s infinite}.skeleton-rect.placeholder{width:auto}.skeleton-rect.block{display:block;width:100%;height:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
